import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { from } from 'rxjs/internal/observable/from';
import { ApiNameList } from '../../../environments/api-name-list';
import { AppConfigService } from '../../main/app-config.service';
import { AppConstants } from '../constants/app-constants';
import { DataService } from './data.service';
import { UserCacheService } from './user-cache.service';

@Injectable()
export class HttpClientService {
    refreshTokenCalled = false;
    private environment: any;
    constructor(
        private http: HttpClient,
        private userCacheService: UserCacheService,
        public dataService: DataService,
        public router: Router,
        private appConfigService: AppConfigService
    ) {
        this.environment = this.appConfigService.getConfig();
    }

    getCookie(name: string) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for(let i=0;i < ca.length;i++) {
            let c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    setCookie(name: string,value: string) {
        const isSecure = window.location.protocol === 'https:' ? '; Secure' : '';
        document.cookie = name + "=" + (value || "") + "; path=/; SameSite=Strict" + isSecure;
    }

    createCustomHeaders(headerParam?: HttpHeaders) {
        if (headerParam) {
            return headerParam;
        } else {
            let headers = new HttpHeaders();
            headers = headers.set('userid', this.userCacheService.getUserData(AppConstants.USERID) ?? '');
            // headers = headers.set('authorization', localStorage.getItem(AppConstants.TOKEN) ?? '');
            headers = headers.set('authorization', this.getCookie(AppConstants.TOKEN) ?? '');
            headers = headers.set('clientcorrelationid', this.userCacheService.getUserData(AppConstants.CLIENT_CORRELATION_ID) ?? '');
            headers = headers.set('sae-portal', 'university');
            return headers.set('Content-Type', 'application/json');
        }

    }

    get(url: string) {
        const headers = this.createCustomHeaders();
        return from(this.tokenRefresh(url, 'Get', headers));
    }


    async tokenRefresh(url: string, method: string, headers?: HttpHeaders, data?: any) {
        if (url.includes('/secure/')) {
            // const token = localStorage.getItem(AppConstants.TOKEN) ?? '';
            const token = this.getCookie(AppConstants.TOKEN) ?? '';
            if (token) {
                const jwtHelper = new JwtHelperService();
                const expTime = jwtHelper.getTokenExpirationDate(token);
                const diff = (expTime.getTime() - new Date().getTime()) / 1000;
                if (diff < this.environment.refreshTokenTimeInterval && !this.refreshTokenCalled) {
                    this.refreshTokenCalled = true;
                    const response: any = await this.http.get(ApiNameList.restApi.baseUrl + ApiNameList.restApi.refreshToken, { headers: headers }).toPromise();
                    this.refreshTokenCalled = false;
                    if (response && response.status === 'SUCCESS') {
                        // localStorage.setItem(AppConstants.TOKEN, response.token);
                        this.setCookie(AppConstants.TOKEN, response.token);
                    } else {
                        await this.logout();
                    }

                }
            }
        }
        if (method === 'Get') {
            return this.http.get(url, { headers: headers }).toPromise();
        } else {
            return this.http.post(url, JSON.stringify(data), { headers: headers }).toPromise();
        }
    }
    async logout() {
        let response = await this.http.get(ApiNameList.restApi.baseUrl + ApiNameList.restApi.logout).toPromise();
        this.userCacheService.eraseAllUserData();
        localStorage.clear();
        this.dataService.userLoggedIn(false);
        // this.router.navigate(['/login']);
        window.location.href = '/logout';
    }
    post(url: string, data: any, headerParam?: HttpHeaders) {
        const headers = this.createCustomHeaders(headerParam);
        return from(this.tokenRefresh(url, 'Post', headers, data));
        //return this.http.post(url, JSON.stringify(data), { headers: headers });
    }
}
